import Vue from 'vue'
import App from './App.vue'
// router与store
import router from './router'
import store from './store'

// 引入element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入百度地图vue
import BaiduMap from 'vue-baidu-map';
// 引入echarts
import * as echarts from 'echarts'
// 全局组件
import '@/components'

// 引入api
import api from './api/index.js'
// import adm from './api/adm.js'
import pub from './public/index.js'
import ver from './verification/index.js'
import VueQriously from 'vue-qriously'

Vue.prototype.$api = api
// Vue.prototype.$adm = adm
Vue.prototype.$pub = pub
Vue.prototype.$ver = ver
Vue.prototype.$echarts = echarts

Vue.use(ElementUI)
Vue.use(VueQriously)
// 使用百度地图
Vue.use(BaiduMap, {
	ak: 'm05gIG2RyGl81OKWWtdzQrHovb3AW0sX'
})

Vue.config.productionTip = false

if (pub.getStorage('adm_token')) {
	let userInfo = JSON.parse(pub.getStorage('admUserInfo'))
	store.state.admLoginFlag = true
	store.commit('saveAdmUserInfo', userInfo)
}
if (pub.getStorage('page_token')) {
	let userInfo = JSON.parse(pub.getStorage('userinfo'))
	store.state.hasLogin = true
	store.commit('saveUserinfo', userInfo)
}

router.beforeEach((to, from, next) => {
	// 设置title
	if (to.meta.title) {
		document.title = to.meta.title
	}
	// 管理系统拦截无效用户
	let manage = ['/manage', '/database', '/account', '/users', '/commodity', '/compile', '/classify', '/tags',
		'/activity', '/activityedit', '/item', '/itemedit', '/attention', '/order', '/earnest', '/swiper',
		'/issue', '/article', '/category', '/config', '/orderDetail'
	]
	// 如果是登录页，不要检查
	if (manage.indexOf(to.path) >= 0 && !pub.getStorage('adm_token')) {
		router.push({
			path: '/notFound'
		})
		return
	}
	next()
})


new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
